// Standard query key for active tertiary tab state. Domain-specific filters should use their own keys.
export const TERTIARY_NAVIGATION_QUERY_PARAMS = {
  tab: 'tab',
} as const;
